var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2571 24.3901C20.0999 24.3901 24.0259 20.4641 24.0259 15.6213C24.0259 10.7784 20.0999 6.85248 15.2571 6.85248C10.4142 6.85248 6.48828 10.7784 6.48828 15.6213C6.48828 20.4641 10.4142 24.3901 15.2571 24.3901ZM22.5259 15.6213C22.5259 19.6357 19.2715 22.8901 15.2571 22.8901C11.2426 22.8901 7.98828 19.6357 7.98828 15.6213C7.98828 11.6068 11.2426 8.35248 15.2571 8.35248C19.2715 8.35248 22.5259 11.6068 22.5259 15.6213ZM15.4752 12.1501C15.4752 11.7359 15.1394 11.4001 14.7252 11.4001C14.311 11.4001 13.9752 11.7359 13.9752 12.1501V16.4176V16.7926L14.2752 17.0176L16.9705 19.039C17.3018 19.2876 17.7719 19.2204 18.0205 18.889C18.269 18.5577 18.2018 18.0876 17.8705 17.839L15.4752 16.0426V12.1501Z",
    fill: "#484848"
  })));
}

export default SvgFullTime;